import { call, cancelled, select, take, takeEvery } from 'redux-saga/effects';

import { ACTIVE_VENUE_CHANGED } from 'features/App';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenueId } from 'selectors/general';

import { persistClassId } from './WeeklyEarnings/WeeklyEarnings.helpers';

export function* handleActiveVenueChange(dependencies, action) {
  // Clear the stored class selection for the venue we're leaving
  const currentVenueId = yield select(selectActiveVenueId);
  persistClassId(currentVenueId, null);
  yield call(dependencies.navigate, makePath.smartRate(action.venueId));
}

export function* watchSmartRate(dependencies) {
  try {
    yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, dependencies);
    // Block until this saga is cancelled by the store (route leave).
    // Using a sentinel action that is never dispatched keeps the saga alive
    // without a busy loop while still supporting redux-saga cancellation.
    yield take('@@smartrate/NEVER');
  } finally {
    if (yield cancelled()) {
      // User navigated away from SmartRate — clear the stored class selection
      const venueId = yield select(selectActiveVenueId);
      persistClassId(venueId, null);
    }
  }
}
